import { render } from "./ProgramView.vue?vue&type=template&id=42c8a764&scoped=true"
import script from "./ProgramView.vue?vue&type=script&lang=js"
export * from "./ProgramView.vue?vue&type=script&lang=js"

import "./ProgramView.vue?vue&type=style&index=0&id=42c8a764&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42c8a764"]])

export default __exports__